/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React from 'react';
import { View } from 'react-native';
import { isWeb } from '@global/screens';
import Colors from '@global/colors';
import ItemDetail from '@components/global/ItemDetail';
import Image from '@components/global/Image';
import SociollaText from '@components/sociolla/SociollaText';

const defaultPhoto = require('@/assets/img/default/user-default.png');

const TargetLoyaltyPoint = ({ loyaltyType = 'add', detailLoyalty = {} }) => {
  return (
    <View style={{ paddingBottom: 20 }}>
      <View
        style={{
          paddingHorizontal: 20,
          paddingBottom: 20,
          borderBottomColor: Colors.grey0,
          borderBottomWidth: 1,
        }}>
        <View
          style={{
            width: 175,
            paddingHorizontal: 15,
            paddingVertical: 18,
            borderRadius: 5,
            backgroundColor: Colors.blue7,
          }}>
          <SociollaText style={{ color: Colors.grey2, marginBottom: 7 }}>
            Current Loyalty Point
          </SociollaText>
          <SociollaText type="medium" style={{ fontSize: 24 }}>
            {detailLoyalty.loyalty_points}
          </SociollaText>
        </View>
      </View>
      <View style={{ width: isWeb ? '50%' : '100%', paddingHorizontal: 20 }}>
        <ItemDetail
          centered
          name="Submitted By"
          value={
            detailLoyalty.created_by?.name ? (
              <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                <View
                  style={{
                    width: 20,
                    height: 20,
                    overflow: 'hidden',
                    borderRadius: 20,
                    marginRight: 8,
                  }}>
                  <Image
                    source={{ uri: detailLoyalty.created_by?.image || '' }}
                    style={{ width: 20, height: 20 }}
                    width={20}
                    height={20}
                    defaultSource={defaultPhoto}
                  />
                </View>
                <SociollaText style={{ fontSize: 12 }}>
                  {detailLoyalty.created_by.name}
                </SociollaText>
              </View>
            ) : (
              '-'
            )
          }
        />
        <ItemDetail
          name={loyaltyType == 'add' ? 'Addition Point' : 'Deduction Point'}
          value={detailLoyalty.points ? detailLoyalty.points : 0}
        />
        <ItemDetail
          name="Noted"
          value={detailLoyalty.notes ? detailLoyalty.notes : '-'}
        />
      </View>
    </View>
  );
};

export default TargetLoyaltyPoint;
